module.exports = __webpack_public_path__ + "static/media/ss.2a6738aa.webp";